export default __webpack_public_path__ + "locales/ja-JP/Profile.json?hash=e2c709d3d5cb22059c61b69fcbb215b4";